module.exports = __webpack_public_path__ + "img/Back-to-top.9938c813.png";